// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* eslint-disable max-len */
/* ─── Minimal custom styles that can't be done with Tailwind alone ─── */
.dtb-select[data-v-1871d684] {
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-light) / var(--tw-bg-opacity));
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-duration: 150ms;
  -webkit-appearance: auto;
     -moz-appearance: auto;
          appearance: auto
}
.dtb-select[data-v-1871d684]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-secondary) / 0.18)
}
.dtb-input[data-v-1871d684] {
  box-sizing: border-box;
  display: block;
  width: 100%;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-stroke) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-light) / var(--tw-bg-opacity));
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 13px;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-property: all;
  transition-duration: 150ms
}
.dtb-input[data-v-1871d684]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-secondary) / 0.18)
}
.dtb-field-label[data-v-1871d684] {
  margin-bottom: 3px;
  display: block;
  font-size: 12px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity))
}
.dtb-error[data-v-1871d684] {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-alert) / var(--tw-text-opacity))
}
.dtb-hint[data-v-1871d684] {
  margin-top: 4px;
  font-size: 11px;
  --tw-text-opacity: 1;
  color: rgb(139 139 151 / var(--tw-text-opacity))
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
